export default __webpack_public_path__ + "static/media/filterIconMarked.defa2160.svg";